import React from 'react';
import { TEAM_PHOTOS } from '../data/site';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
export function Team() {
  return <section id="equipo" className="bg-white py-24 sm:py-32 lg:py-40" data-id="element-237" data-mp="umk3gmlzztra">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-238" data-mp="yoyqliwp9fod">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-end" data-id="element-239" data-mp="13hru63gfmhyv">
          <Reveal className="lg:col-span-7" data-id="element-240" data-mp="13j2x6121zlox">
            <SectionHeading eyebrow="Nuestro equipo" title="Personas que hacen la diferencia." description="Asesores, armadores y repartidores que conocen cada producto que vendemos y cada casa a la que llegan." data-id="element-241" data-mp="18f9rsxp01ark" />
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5" data-id="element-242" data-mp="1mgm6z6wc58ce">
            <blockquote className="rounded-4xl border-l-2 border-brand bg-haze p-8 text-lg sm:text-xl font-medium leading-snug text-ink" data-id="element-243" data-mp="1mdzyn51meot4">
              “Detrás de cada venta hay un equipo comprometido con ayudarte a encontrar el hogar que
              imaginás.”
            </blockquote>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-244" data-mp="1hs0foru4ded5">
          {TEAM_PHOTOS.map((photo, i) => <Reveal key={photo.caption} delay={i * 0.1} className={photo.wide ? 'sm:col-span-2 lg:col-span-3' : ''} data-id="element-245" data-mp="1cse1og6gvu3a" data-mpi={i}>
              <figure className="group relative h-full overflow-hidden rounded-4xl bg-ink" data-id="element-246" data-mp="25hl1dihnqpq4">
                <img src={photo.src} alt={photo.alt} loading="lazy" decoding="async" className={`w-full object-cover object-center transition-transform duration-[900ms] ease-out group-hover:scale-105 ${photo.wide ? 'h-[240px] sm:h-[320px] lg:h-[420px]' : 'h-[320px] sm:h-[420px] lg:h-[480px]'}`} data-id="element-247" data-mp="25f8mxfb3yxht" />
                <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-ink/85 to-transparent" aria-hidden="true" data-id="element-248" data-mp="f79rvpalwoc4" />
                <figcaption className="absolute inset-x-0 bottom-0 p-7" data-id="element-249" data-mp="37bwj1806lozh">
                  <span className="inline-flex rounded-full bg-white/15 px-4 py-2 text-sm font-medium text-white backdrop-blur-md" data-id="element-250" data-mp="2tbv80zq7d16a">
                    {photo.caption}
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-251" data-mp="2oe3clvqcmwxc">
          <p className="mt-10 text-center text-sm sm:text-base text-ink-muted" data-id="element-252" data-mp="2ofeh5xrmc8pi">
            Atendiendo consultas, armando muebles y coordinando entregas: el mismo equipo, todos los
            días, en el mismo local.
          </p>
        </Reveal>
      </div>
    </section>;
}